<template>
  <div>
    <h2 class="text-base font-medium mb-3">
      {{ $t('Services.AddOrderTitle') }}
    </h2>
    <div class="text-sm text-neutral-700 mb-4">
      {{ $t('Services.AddOrderDescription') }}
    </div>
    <div class="mb-4">
      <span class="input-label">
        {{ $t('Services.SelectRoomLabel') }}
      </span>
      <multiselect
        v-model="selectedBookable"
        class="multiselect-is-single"
        :close-on-select="true"
        :allow-empty="false"
        :options="bookables"
        label="name"
        open-direction="bottom"
        track-by="id"
      />
    </div>
    <div class="mb-4">
      <span class="input-label">
        {{ $t('Services.SelectProviderLabel') }}
      </span>
      <multiselect
        v-model="selectedProvider"
        class="multiselect-is-single"
        :close-on-select="true"
        :allow-empty="false"
        :placeholder="$t('Services.SelectProviderPlaceholder')"
        :options="providerOptions"
        label="name"
        open-direction="bottom"
        track-by="id"
      />
    </div>
    <button
      class="btn btn-primary mb-3 w-full"
      :disabled="!selectedBookable || !selectedProvider"
      @click="$emit('create', {
        bookable: selectedBookable,
        service_provider: selectedProvider
      })"
    >
      {{ $t('Services.Add') }}
    </button>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect,
  },
  props: {
    bookables: { type: Array, required: true },
  },
  data: () => ({
    selectedBookable: null,
    selectedProvider: null,
  }),
  computed: {
    providerOptions () {
      return this.selectedBookable?.location?.building?.service_providers || []
    },
  },
  mounted () {
    if (this.bookables.length === 1) {
      this.selectedBookable = this.bookables[0]
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
